import { createClient } from 'https://esm.sh/@supabase/supabase-js@2';

// ⚠️ 重要：请替换为你的实际Supabase配置
const SUPABASE_URL = 'https://krrinwpwdplybgaevqhy.supabase.co';  // 替换为你的项目URL
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imtycmlud3B3ZHBseWJnYWV2cWh5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIxMzg4NzUsImV4cCI6MjA2NzcxNDg3NX0.HylAu9bTPFVhCD0DwDP_uy5GhYblVrioi95BZzs7i4o';          // 替换为你的匿名密钥

// 创建 Supabase 客户端
const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// 全局变量
let currentUser = null;
let sessionInterval = null;

// 初始化应用
document.addEventListener('DOMContentLoaded', async () => {
    console.log('Supabase Auth 测试应用初始化...');
    
    // 检查现有会话
    await checkUserSession();
    
    // 设置事件监听器
    setupEventListeners();
    
    // 开始会话监控
    startSessionMonitoring();
});

// 检查用户会话
async function checkUserSession() {
    try {
        const { data: { user }, error } = await supabase.auth.getUser();
        
        if (error) {
            console.error('获取用户会话失败:', error);
            showLoginSection();
            return;
        }
        
        if (user) {
            currentUser = user;
            showDashboardSection();
            updateUserInfo(user);
            console.log('用户已登录:', user.email);
        } else {
            showLoginSection();
            console.log('用户未登录');
        }
    } catch (error) {
        console.error('检查会话时出错:', error);
        showLoginSection();
    }
}

// 设置事件监听器
function setupEventListeners() {
    // 登录表单
    const loginForm = document.getElementById('login-form');
    loginForm.addEventListener('submit', handleLogin);
    
    // 注册表单
    const registerForm = document.getElementById('register-form');
    registerForm.addEventListener('submit', handleRegister);
    
    // 监听认证状态变化
    supabase.auth.onAuthStateChange((event, session) => {
        console.log('认证状态变化:', event, session);
        
        switch(event) {
            case 'SIGNED_IN':
                currentUser = session.user;
                showDashboardSection();
                updateUserInfo(session.user);
                showModal('登录成功', `欢迎回来，${session.user.email}！`);
                break;
                
            case 'SIGNED_OUT':
                currentUser = null;
                showLoginSection();
                showModal('已登出', '您已成功登出。');
                break;
                
            case 'TOKEN_REFRESHED':
                console.log('令牌已刷新');
                updateSessionMonitor('令牌已刷新');
                break;
                
            case 'USER_UPDATED':
                currentUser = session.user;
                updateUserInfo(session.user);
                break;
        }
    });
}

// 处理登录
async function handleLogin(event) {
    event.preventDefault();
    
    const email = document.getElementById('email').value;
    const password = document.getElementById('password').value;
    
    if (!email || !password) {
        showModal('错误', '请填写邮箱和密码');
        return;
    }
    
    try {
        console.log('正在登录...', { email });
        
        const { data, error } = await supabase.auth.signInWithPassword({
            email: email,
            password: password
        });
        
        if (error) {
            console.error('登录失败:', error);
            showModal('登录失败', error.message);
            return;
        }
        
        console.log('登录成功:', data);
        
    } catch (error) {
        console.error('登录过程中出错:', error);
        showModal('错误', '登录过程中发生错误，请重试。');
    }
}

// 处理注册
async function handleRegister(event) {
    event.preventDefault();
    
    const email = document.getElementById('reg-email').value;
    const password = document.getElementById('reg-password').value;
    const confirmPassword = document.getElementById('reg-confirm-password').value;
    
    if (password !== confirmPassword) {
        showModal('错误', '两次输入的密码不一致');
        return;
    }
    
    if (password.length < 6) {
        showModal('错误', '密码长度至少为6位');
        return;
    }
    
    // 邮箱格式验证增强
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
        showModal('邮箱格式错误', '请输入有效的邮箱地址');
        return;
    }
    
    // 检查是否是测试邮箱
    const testDomains = ['example.com', 'test.com', 'fake.com'];
    const domain = email.split('@')[1];
    if (testDomains.includes(domain)) {
        showModal('测试邮箱提醒', '检测到测试邮箱，建议使用真实邮箱如gmail.com、outlook.com等');
        return;
    }
    
    try {
        console.log('正在注册新用户...', { email });
        
        const { data, error } = await supabase.auth.signUp({
            email: email,
            password: password,
            options: {
                emailRedirectTo: window.location.origin,
                data: {
                    test_user: true
                }
            }
        });
        
        if (error) {
            console.error('注册失败:', error);
            
            // 提供更详细的错误处理
            let errorMessage = error.message;
            if (error.message.includes('invalid')) {
                errorMessage = '邮箱格式无效，请使用真实邮箱地址';
            } else if (error.message.includes('already registered')) {
                errorMessage = '该邮箱已被注册，请直接登录';
            } else if (error.message.includes('rate limit')) {
                errorMessage = '注册过于频繁，请稍后再试';
            }
            
            showModal('注册失败', errorMessage);
            return;
        }
        
        console.log('注册成功:', data);
        
        if (data.user) {
            showModal('注册成功', 
                `账号创建成功！\n\n` +
                `邮箱: ${data.user.email}\n` +
                `用户ID: ${data.user.id.substring(0, 8)}...\n\n` +
                `请检查您的邮箱完成验证（如需要）`
            );
        }
        
        // 清空表单
        document.getElementById('register-form').reset();
        setTimeout(() => showLoginSection(), 2000);
        
    } catch (error) {
        console.error('注册过程中出错:', error);
        showModal('错误', '注册过程中发生错误，请重试。');
    }
}

// 处理登出
async function handleLogout() {
    try {
        console.log('正在登出...');
        
        const { error } = await supabase.auth.signOut();
        
        if (error) {
            console.error('登出失败:', error);
            showModal('登出失败', error.message);
            return;
        }
        
        console.log('登出成功');
        
    } catch (error) {
        console.error('登出过程中出错:', error);
        showModal('错误', '登出过程中发生错误。');
    }
}

// 测试会话刷新
async function testSessionRefresh() {
    try {
        console.log('正在测试会话刷新...');
        
        const { data, error } = await supabase.auth.refreshSession();
        
        if (error) {
            console.error('会话刷新失败:', error);
            showModal('会话刷新失败', error.message);
            return;
        }
        
        console.log('会话刷新成功:', data);
        showModal('会话刷新成功', '会话令牌已成功刷新。');
        
    } catch (error) {
        console.error('会话刷新测试出错:', error);
        showModal('错误', '会话刷新测试失败。');
    }
}

// 显示登录部分
function showLoginSection() {
    document.getElementById('login-section').classList.remove('d-none');
    document.getElementById('register-section').classList.add('d-none');
    document.getElementById('dashboard-section').classList.add('d-none');
    document.getElementById('user-info').classList.add('d-none');
}

// 显示注册部分
function showRegisterSection() {
    document.getElementById('login-section').classList.add('d-none');
    document.getElementById('register-section').classList.remove('d-none');
    document.getElementById('dashboard-section').classList.add('d-none');
}

// 显示仪表板部分
function showDashboardSection() {
    document.getElementById('login-section').classList.add('d-none');
    document.getElementById('register-section').classList.add('d-none');
    document.getElementById('dashboard-section').classList.remove('d-none');
    document.getElementById('user-info').classList.remove('d-none');
    
    if (currentUser) {
        displayUserDetails(currentUser);
    }
}

// 更新用户信息
function updateUserInfo(user) {
    document.getElementById('user-email').textContent = user.email;
}

// 显示用户详细信息
function displayUserDetails(user) {
    const detailsHtml = `
        <div class="row">
            <div class="col-md-6">
                <strong>用户ID:</strong><br>
                <code class="text-break">${user.id}</code>
            </div>
            <div class="col-md-6">
                <strong>邮箱:</strong><br>
                ${user.email}
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-md-6">
                <strong>创建时间:</strong><br>
                ${new Date(user.created_at).toLocaleString('zh-CN')}
            </div>
            <div class="col-md-6">
                <strong>最后登录:</strong><br>
                ${user.last_sign_in_at ? new Date(user.last_sign_in_at).toLocaleString('zh-CN') : '首次登录'}
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12">
                <strong>邮箱验证状态:</strong>
                <span class="badge ${user.email_confirmed_at ? 'bg-success' : 'bg-warning'}">
                    ${user.email_confirmed_at ? '已验证' : '未验证'}
                </span>
            </div>
        </div>
    `;
    
    document.getElementById('user-details').innerHTML = detailsHtml;
}

// 开始会话监控
function startSessionMonitoring() {
    sessionInterval = setInterval(async () => {
        try {
            const { data: { session } } = await supabase.auth.getSession();
            
            if (session) {
                const expiresAt = new Date(session.expires_at * 1000);
                const now = new Date();
                const timeLeft = Math.floor((expiresAt - now) / 1000);
                
                updateSessionMonitor(`令牌将在 ${Math.floor(timeLeft / 60)} 分钟后过期`);
                
                if (timeLeft < 300) { // 5分钟内过期
                    updateSessionMonitor('令牌即将过期，准备刷新...');
                }
            } else {
                updateSessionMonitor('无活跃会话');
            }
        } catch (error) {
            console.error('会话监控错误:', error);
            updateSessionMonitor('会话监控出错');
        }
    }, 30000); // 每30秒检查一次
}

// 更新会话监控显示
function updateSessionMonitor(message) {
    const monitor = document.getElementById('session-monitor');
    if (monitor) {
        monitor.innerHTML = `<small class="text-muted">${new Date().toLocaleTimeString('zh-CN')} - ${message}</small>`;
    }
}

// 显示模态框
function showModal(title, message) {
    const modal = new bootstrap.Modal(document.getElementById('resultModal'));
    document.getElementById('resultModalTitle').textContent = title;
    document.getElementById('resultModalBody').textContent = message;
    modal.show();
}

// 填充测试账号
window.fillTestAccount = function(type) {
    const timestamp = Date.now();
    switch(type) {
        case 'user1':
            document.getElementById('email').value = 'testuser1@gmail.com';
            document.getElementById('password').value = 'TestPass123!';
            break;
        case 'user2':
            document.getElementById('email').value = 'testuser2@outlook.com';
            document.getElementById('password').value = 'TestPass456!';
            break;
        case 'new':
            showRegisterSection();
            document.getElementById('reg-email').value = `testuser${timestamp}@gmail.com`;
            document.getElementById('reg-password').value = 'TestPass789!';
            document.getElementById('reg-confirm-password').value = 'TestPass789!';
            break;
    }
};

// 显示登录界面
window.showLogin = function() {
    showLoginSection();
};

// 导出全局函数
window.handleLogout = handleLogout;
window.testSessionRefresh = testSessionRefresh;

// 开发模式下的调试信息
if (import.meta.env.DEV) {
    console.log('开发模式已启用');
    console.log('Supabase URL:', SUPABASE_URL);
    console.log('Supabase 客户端已初始化:', supabase);
}